import {TouchableOpacity, View, Text} from '@/components/react-native';
import {Modal} from 'react-native';

type Props = {
  title: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
};
const ConfirmDeleteModal = (props: Props) => {
  const width = window.innerWidth;
  return (
    <Modal visible={true} onDismiss={() => props.onClose()} transparent={true}>
      <View className="w-full flex-1 flex-col items-center justify-center">
        <View className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-[#303030CC]" />
        <View
          className="w-full bg-[#061510] rounded-[12px] p-xl overflow-hidden border-[0.5px] border-[#3030304D] z-[99]"
          style={{
            maxWidth: width * 0.9
          }}
        >
          <Text
            className="w-full text-[#FAFAF9] text-[16px] font-medium tracking-[-0.32px]"
            fontFamily="Geist"
          >
            {props.title}
          </Text>
          <Text
            className="w-full text-[16px] text-[#F1F1F1] mt-[12px] tracking-[-0.32px]"
            fontFamily="Geist"
          >
            {props.description}
          </Text>
          <View className="w-full mt-[16px] flex-row items-end justify-end">
            <TouchableOpacity
              onPress={() => props.onConfirm()}
              className="mr-[16px]"
            >
              <Text
                className="text-[16px] text-[#E94860] text-center font-medium tracking-[-0.32px]"
                fontFamily="Geist"
              >
                Delete
              </Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => props.onClose()}>
              <Text
                className="text-[16px] text-[#38BDF8] tracking-[-0.32px]"
                fontFamily="Geist"
              >
                Cancel
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ConfirmDeleteModal;
